import type { MissionSummaryIndustryPresentation } from "./missionSummaryIndustryPresentation";

export type MissionSummaryIndustryIconProps = Readonly<{
  className?: string;
  presentation: MissionSummaryIndustryPresentation;
}>;

export function MissionSummaryIndustryIcon({
  className,
  presentation,
}: MissionSummaryIndustryIconProps) {
  const sharedProps = {
    className,
    fill: "none",
    stroke: presentation.color,
    strokeWidth: 1.8,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    viewBox: "0 0 24 24",
    "aria-hidden": true as const,
  };

  switch (presentation.icon) {
    case "home":
      return (
        <svg {...sharedProps}>
          <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5Z" />
        </svg>
      );
    case "building":
      return (
        <svg {...sharedProps}>
          <path d="M6 20V6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14" />
          <path d="M9 9h2M9 13h2M13 9h2M13 13h2M4 20h16" />
        </svg>
      );
    case "wrench":
      return (
        <svg {...sharedProps}>
          <path d="M14.7 6.3a4.5 4.5 0 0 0-6.1 6.1L4 17l3 3 4.6-4.6a4.5 4.5 0 0 0 6.1-6.1l-2.2 2.2-2.8-2.8 2.2-2.2Z" />
        </svg>
      );
    case "tractor":
      return (
        <svg {...sharedProps}>
          <path d="M5 17h12M7 17a2 2 0 1 0 0 .01M17 17a2 2 0 1 0 0 .01M5 13h4l2-4h5l2 4h1" />
          <path d="M9 9V6h4v3" />
        </svg>
      );
    case "zap":
      return (
        <svg {...sharedProps}>
          <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z" />
        </svg>
      );
    case "lock":
      return (
        <svg {...sharedProps}>
          <rect x="5" y="11" width="14" height="10" rx="2" />
          <path d="M8 11V8a4 4 0 0 1 8 0v3" />
        </svg>
      );
    case "events":
      return (
        <svg {...sharedProps}>
          <path d="M9 4h6M12 8v4l2 2" />
          <path d="M5 9a7 7 0 1 0 14 0" />
        </svg>
      );
    case "camera":
      return (
        <svg {...sharedProps}>
          <path d="M4 8h3.5L9 6h6l1.5 2H20v10H4V8Z" />
          <circle cx="12" cy="13" r="3" />
        </svg>
      );
    case "map":
      return (
        <svg {...sharedProps}>
          <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Z" />
          <path d="M9 4v16M15 6v16" />
          <circle cx="12" cy="11" r="1.4" fill={presentation.color} stroke="none" />
        </svg>
      );
    case "plus":
    default:
      return (
        <svg {...sharedProps}>
          <path d="M12 5v14M5 12h14" />
        </svg>
      );
  }
}
